import { useListPayments } from '@myrentalmate/api-client';
import { Stack, Typography } from '@mui/material';

import { TablePager, useTablePage } from '../../components/TablePager';
import { okData, okItems } from '../../lib/apiData';
import { PaymentTable } from './PaymentTable';

export function PaymentsPage() {
  const paging = useTablePage();
  const query = useListPayments(paging.params);
  const payments = okItems(query.data);
  return (
    <Stack spacing={2}>
      <div>
        <Typography variant="h5">Payments</Typography>
        <Typography color="text.secondary">
          The latest payments received. To record a new one, open its lease.
        </Typography>
      </div>
      {payments.length === 0 ? (
        <Typography color="text.secondary">No payments yet.</Typography>
      ) : (
        <>
          <PaymentTable payments={payments} showLease />
          <TablePager paging={paging} total={okData(query.data)?.total ?? 0} />
        </>
      )}
    </Stack>
  );
}
